<template>
	<div
		class="relative items-carousel"
		:style="{ visibility: visible ? 'visible' : 'hidden' }"
	>
		<div :id="uuid" class="glide">
			<div data-glide-el="controls">
				<v-btn
					fab
					depressed
					small
					color="info"
					class="arrow-container nav-button-left custom-button-fab"
					data-glide-dir="<"
					:style="{ left: controlMx }"
				>
					<v-icon dark size="40">keyboard_arrow_left</v-icon>
				</v-btn>
				<v-btn
					fab
					depressed
					small
					color="info"
					class="arrow-container nav-button-right custom-button-fab"
					data-glide-dir=">"
					:style="{ right: controlMx }"
				>
					<v-icon dark size="40">keyboard_arrow_right</v-icon>
				</v-btn>
			</div>
			<div class="glide__track" data-glide-el="track">
				<div class="glide__slides">
					<div class="glide__slide" v-for="(item, i) of items" :key="i">
						<slot :item="item"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm';

// Todo: enhance the jon-selection-carousel implementation using this new component
export default {
	name: 'PItemsCarousel',
	props: {
		items: {
			default: () => [],
		},
		perView: {
			default: () => 5,
		},
		breakpointPerView: {
			default: () => ({
				800: {
					perView: 3,
				},
				480: {
					perView: 1,
				},
			}),
		},
		controlMx: {
			default: () => '-80px',
		},
		uuid: {
			default: () => 'item-slider',
		},
	},
	data() {
		return {
			glideRef: null,
			visible: false,
		};
	},
	updated() {
		setTimeout(() => {
			this.glideInit();
		}, 500);
	},
	beforeDestroy() {
		if (this.glideRef && typeof this.glideRef.destroy === 'function') {
			this.glideRef.destroy();
		}
	},
	methods: {
		glideInit() {
			const el = document.getElementById(this.uuid);
			if (!el) {
				console.warn('Glide root element not found:', this.uuid);
				return;
			}
			this.glideRef = new Glide(el, {
				type: 'slider',
				perView: this.perView,
				focusAt: 0,
				breakpoints: this.breakpointPerView,
			});
			this.glideRef.on('mount.after', () => {
				this.visible = true;
			});
			this.glideRef.mount({ Controls, Breakpoints });
		},
	},
	watch: {
		items: {
			handler() {
				this.$nextTick(() => {
					this.glideInit();
				});
			},
			immediate: true,
		},
		perView: {
			handler() {
				this.$nextTick(() => {
					if (this.glideRef) {
						this.glideRef.destroy();
					}
					this.glideRef.update({
						preView: this.perView,
					});
				});
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.items-carousel {
	transition: visibility 0.3s ease-in;
}

.nav-button-left {
	position: absolute;
	top: calc(50% - 30px);
}
.nav-button-right {
	position: absolute;
	top: calc(50% - 30px);
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/content/p-items-corousel.vue